import { render } from "./NcrmPrivacyEvidenceDrawer.vue?vue&type=template&id=3f48ab3c"
import script from "./NcrmPrivacyEvidenceDrawer.vue?vue&type=script&lang=js"
export * from "./NcrmPrivacyEvidenceDrawer.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__